module.exports = __webpack_public_path__ + "static/media/ic_insta_fund_redemption.fe91d7ed.svg";